import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
}

h1{
  color: ${props => props.theme.colors.white}
}

#functionButtons{
  display: flex;
  gap: 15px;

}

#new-chat-title {
  display: flex;
  position: relative;
  padding: 10px;
  margin-top:1px;
  margin-left:1px;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.secondary};
  height: ${props => props.theme.spacing.spacing_09};
  gap: 50px;
  h1{
    font-size: 2em;
  }
  button{
    position: absolute;
    left: 5px;
    top: 4px;
    bottom: 10px;
  }
}

#new-chat{
  display:flex;
  flex-direction: column;
  color: ${p => p.theme.colors.black};

  ul{
    padding-left: 0px;
    cursor: pointer;
  }

  li{
    padding: 15px 15px 15px 15px;
    font-size: 1.2em;
    list-style: none;
    background-color: ${props => props.theme.colors.primary};
    text-decoration: none;
    border-bottom: 1px solid black;
  }
  li:nth-child(even)
  {
    background-color: ${props => props.theme.colors.primary};
  }  
}


@media (max-width: 1000px){
  button{
    font-size: ${props => props.theme.spacing.spacing_04};
    width: ${props => props.theme.spacing.spacing_15};
    height: ${props => props.theme.spacing.spacing_07};
  }
}
@media (max-width: 875px){
  button{
    font-size: ${props => props.theme.spacing.spacing_03};
    width: ${props => props.theme.spacing.spacing_12};
    height: ${props => props.theme.spacing.spacing_07};
  }
}


`